<template>
	<div>
		<AppFilter @apply="onFilter" v-model="filters" @retainValues = "retainFilter" ref="appFilter"/>
	</div>
</template>

<script>
	import AppFilter from "@/components/core/indexNew.vue";
	export default {
        name:"PrestigeCampaignFilter",
		props: {
			// selectedVendorFilter: {},
			// selectedCampGroupFilter: {}
		},
		beforeMount() {},
		components: {
			AppFilter
		},
		watch: {
			// selectedVendorFilter() {
			// 	this.setFilters();
			// },
			// selectedCampGroupFilter() {
			// 	this.setFilters();
			// }
		},
		computed: {
			campaignsFilter:{
				set(val){
					this.$store.commit('updateCampaignsFilter',val)
				},
				get(){
					return this.$store.state.campaignsFilter
				}
			},
			selectedCampaignList: {
				get() {
					return this.$store.state.campaign.campaignToAddToGroupList;
				},
				set(val) {
					this.$store.state.campaign.campaignToAddToGroupList = val;
				}
			},
			actionSelectionControl: {
				set(val) {
					this.$store.state.campaign.actionSelectionControl = val
				},
				get() {
					return this.$store.state.campaign.actionSelectionControl
				}
			},
			// vendorsList() {
			// 	// set(val) {
			// 	// 	this.$store.commit("updateVendorList", val);
			// 	// },
			// 	// get() {
			// 	return this.$store.state.vendorList;
			// 	// }
			// },
			// campaignGroupFilterList() {
			// 	// set(val) {
			// 	// 	this.$store.commit(
			// 	// 		"campaign/updateCampaignGroupFilterList",
			// 	// 		val
			// 	// 	);
			// 	// },
			// 	// get() {
			// 	return this.$store.state.campaign.campaignGroupFilterList;
			// 	// }
			// }
		},
		mounted() {
            //fetch all the tags and add them to filter 
            this.getPrestigeTagList();
			if(Object.keys(this.$store.state.campaign.prestigeAdvanceFilter).length && this.campaignsFilter.length){
				this.filters = JSON.parse(JSON.stringify(this.campaignsFilter))
				this.$refs["appFilter"].setFilterActive();
			}
			else{
				this.setFilters();
				// this.$refs["appFilter"].setFilterInActive();
			}
		},
		methods: {
			retainFilter(data){
				if(Object.keys(this.$store.state.campaign.advanceFilter).length){
					this.filters = JSON.parse(JSON.stringify(this.campaignsFilter)) || []
				}
				else{
					this.filters = JSON.parse(JSON.stringify(data)) 
				}
				
			},
            getPrestigeTagList(){
                const vm = this;
                this.$store.dispatch("campaign/getPrestigeTagList",{}).then((res)=>{
                    if(Object.keys(res).length){
                        this.brandList = res.brand.map(x=>{
                            return {
                                name:x.title,
                                code:x.id
                            }
                        })
                        this.strategyList = res.strategy.map(x=>{
                            return {
                                name:x.title,
                                code:x.id
                            }
                        })
                        this.countryList = res.country.map(x=>{
                            return {
                                name:x.title,
                                code:x.id
                            }
                        })
                        this.segmentList = res.segment.map(x=>{
                            return {
                                name:x.title,
                                code:x.id
                            }
                        })
                        this.setFilters();
                    }
                })
            },
			async onFilter(input) {
				let filters = {};
				for (var i = 0; i < input.length; i++) {
                    {
						filters[input[i].name] = input[i].value;
					}
                }
				filters.advanceSearchType = "campaign";
				let payload = {};
				if(filters["campaign_type"]){
					payload.campaign_type = filters["campaign_type"].code
				}
				if(filters["mso"]){
					payload.state = filters["mso"].name
				}
				if(filters["status"]){
					payload.status = filters["status"].code
				}
                if(filters["brand_tag"]){
                    payload.brand_tag = filters["brand_tag"].code
                }
                if(filters["strategy_tag"]){
                    payload.strategy_tag = filters["strategy_tag"].code
                }
                if(filters["country_tag"]){
                    payload.country_tag = filters["country_tag"].code
                }
                if(filters["segment_tag"]){
                    payload.segment_tag = filters["segment_tag"].code
                }
				 ;
				this.resetCampAction()
				this.$store.state.currentPageNumber = 1;
				this.$store.commit("campaign/setPrestigeAdvanceFilterAttributes", payload);
				this.$store.dispatch("campaign/getCampaignList");
			},
			resetCampAction(){
				this.actionSelectionControl = false
				this.selectedCampaignList = []
			},
			setFilters() {
				this.filters = [];
                let vm=this;
				this.filters = [
                    {
						name: "break",
						type: "break"
					},
					{
						name: "campaign_type",
						label: "Campaign type",
						type: "select",
						padding:true,
						placeholder: "Select campaign type",
						value: [],
						enabled: false,
						values: [
							{
								name: "Sponsored Products",
								code: "sponsoredProducts"
							},
							{
								name: "Sponsored Brands",
								 code: "sponsoredBrands"
							 },
							 {
								 name:"Sponsored Display",
								 code:"sponsoredDisplay"
							 }
						]
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "mso",
						label: "State",
						type: "select",
						placeholder: "Select State",
						padding:true,
						value: [],
						enabled: false,
						values: [
							{ name: "AMSO", code: "ams_shutoff" },
							{ name: "MLSO", code: "midnight_shutoff" },
							{ name: "MNSO", code: "ml_shutoff" },
							{ name: "ACTIVE", code: "active" }
						]
					},
					{
						name: "break",
						type: "break"
                    },
                    {
						name: "status",
						label: "Status",
						type: "select",
						padding:true,
						placeholder: "Select Status",
						value: [],
						enabled: false,
						values: [
							{
								name: "Enabled",
								code: "enabled"
							},
                            { name: "Paused", code: "paused" },
                            { name: "Archived", code: "archived" }
						]
                    },
                    {
						name: "break",
						type: "break"
                    },
                    {
                        name:'brand_tag',
                        label:"Brand Tag",
                        type:"select",
                        placeholder:"Select Brand Tag",
                        value:[],
                        enabled:false,
                        values :this.brandList
                    },
                    {
						name: "break",
						type: "break"
                    },
                    {
                        name:'strategy_tag',
                        label:"Strategy Tag",
                        type:"select",
                        placeholder:"Select Strategy Tag",
                        value:[],
                        enabled:false,
                        values :this.strategyList
                    },
                    {
						name: "break",
						type: "break"
                    },
                    {
                        name:'country_tag',
                        label:"Country Tag",
                        type:"select",
                        placeholder:"Select Country Tag",
                        value:[],
                        enabled:false,
                        values :this.countryList
                    },
                    {
						name: "break",
						type: "break"
                    },
                    {
                        name:'segment_tag',
                        label:"Segment Tag",
                        type:"select",
                        placeholder:"Select Segment Tag",
                        value:[],
                        enabled:false,
                        values :this.segmentList
                    },
					{
						name: "break",
						type: "break"
                    }
				];
				this.filters.forEach(filter=>{
					if(filter.name=="brand_tag"||filter.name=="strategy_tag"||filter.name=="country_tag"||filter.name=="segment_tag"){
						filter.values.unshift({code:"untagged",name:"Untagged"})
						if(this.$store.state.campaign.getUntagged){
							filter.value = {
								code:"untagged",
								name:"Untagged"
							}
							filter.enabled=true;
						}
					}
				})
				// if(this.$store.state.campaign.getUntagged){
				// 	this.onFilter(this.filters);
				// }
				this.campaignsFilter = JSON.parse(JSON.stringify(this.filters))
			}
			// setVendor(selectedVendorId) {
			// 	var data = { code: "", name: "" };
			// 	for (var i = 0; i < this.vendorsList.length; i++) {
			// 		if (selectedVendorId == this.vendorsList[i].id) {
			// 			data.code = this.vendorsList[i].id;
			// 			data.name = this.vendorsList[i].name;
			// 			break;
			// 		}
			// 	}
			// 	return data;
			// },
			// setCampGrp(selectedCampGrpId) {
			// 	var data = { code: "", name: "" };
			// 	for (var i = 0; i < this.campaignGroupList.length; i++) {
			// 		if (selectedCampGrpId == this.campaignGroupList[i].id) {
			// 			data.code = this.campaignGroupList[i].id;
			// 			data.name = this.campaignGroupList[i].name;
			// 			break;
			// 		}
			// 	}
			// 	return data;
			// }
		},
		data() {
			return {
				filters: [],
                brandList:[],
                strategyList:[],
                countryList:[],
                segmentList:[]
			};
		}
	};
</script>
<style lang="scss">
.multiselect__content-wrapper {
	z-index: 1001;
}
</style>
